export default __webpack_public_path__ + "static/media/Intelez.4ced6c4d.png";